import { render, staticRenderFns } from "./AlterarStatus.vue?vue&type=template&id=a8ee9ce6"
import script from "./AlterarStatus.vue?vue&type=script&lang=js"
export * from "./AlterarStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports